import { Context } from "@/core/context";
import { DBEntity, DbLine } from "@/CadEngine";
import { Vector3 } from "three";
import { FMathUtils } from "./FMathUtils";
import * as THREE from "three";
import { DrawWallRoadAcceptParams, drawWallType } from "@/core/Parameters";

export namespace WasmUtil {
  export class Point_2 {
    x: number;
    y: number;

    constructor(x: number, y: number) {
      this.x = x;
      this.y = y;
    }
  }
  export class Points_2 {
    points: Point_2[];

    constructor() {
      this.points = [];
    }
  }
  export class Line_2 {
    start: Point_2;
    end: Point_2;

    constructor(start: Point_2, end: Point_2) {
      this.start = start;
      this.end = end;
    }
  }

  export class Circle_2 {
    center: Point_2;
    radius: number;
    constructor(center: Point_2, radius: number) {
      this.center = center;
      this.radius = radius;
    }
  }
  export class Arc_2 {
    center: Point_2;
    radius: number;
    startAngle: number;
    endAngle: number;
    constructor(
      center: Point_2,
      radius: number,
      startAngle: number,
      endAngle: number
    ) {
      this.center = center;
      this.radius = radius;
      this.startAngle = startAngle;
      this.endAngle = endAngle;
    }
  }

  export class Ellipse_2 {
    center: Point_2;
    major: number;
    minor: number;
    angle: number;
    constructor(center: Point_2, major: number, minor: number, angle: number) {
      this.center = center;
      this.major = major;
      this.minor = minor;
      this.angle = angle;
    }
  }
  export class EllipticArc_2 {
    center: Point_2;
    major: number;
    minor: number;
    startAngle: number;
    endAngle: number;
    clockwise: boolean;
    angle: number;
    constructor(
      center: Point_2,
      major: number,
      minor: number,
      startAngle: number,
      endAngle: number,
      clockwise: boolean,
      angle: number
    ) {
      this.center = center;
      this.major = major;
      this.minor = minor;
      this.startAngle = startAngle;
      this.endAngle = endAngle;
      this.clockwise = clockwise;
      this.angle = angle;
    }
  }

  export class Polyline_2 {
    items: { x: number; y: number; z: number; bulge: number }[];
    isClose: boolean;

    constructor(
      items: { x: number; y: number; z: number; bulge: number }[],
      isClose: boolean
    ) {
      this.items = items;
      this.isClose = isClose;
    }
  }

  export function getWasmObj(content: Context) {
    return content.wasmObj || {};
  }

  export function getAuxiliaryObj(content: Context) {
    return content.auxiliaryObj || {};
  }

  function BuildPoint_2(content: Context, point: Point_2) {
    let obj: any = getWasmObj(content);
    return new obj.Point_2(point.x, point.y);
  }

  function BuildLine_2(content: Context, line: Line_2) {
    let obj: any = getWasmObj(content);
    return new obj.Line_2(
      BuildPoint_2(content, line.start),
      BuildPoint_2(content, line.end)
    );
  }

  function BuildCircle_2(content: Context, circle: Circle_2) {
    let obj: any = getWasmObj(content);
    return new obj.Circle_2(
      BuildPoint_2(content, circle.center),
      circle.radius
    );
  }

  function BuildEllipse_2(content: Context, ellipse: Ellipse_2) {
    let obj: any = getWasmObj(content);
    return new obj.Ellipse_2(
      BuildPoint_2(content, ellipse.center),
      ellipse.major,
      ellipse.minor,
      ellipse.angle
    );
  }

  function BuildEllipticArc_2(content: Context, ellipse: EllipticArc_2) {
    let obj: any = getWasmObj(content);
    return new obj.EllipticArc_2(
      BuildPoint_2(content, ellipse.center),
      ellipse.major,
      ellipse.minor,
      ellipse.angle,
      ellipse.startAngle,
      ellipse.endAngle,
      ellipse.clockwise
    );
  }

  function BuildArc_2(content: Context, arc: Arc_2) {
    let obj: any = getWasmObj(content);
    return new obj.Arc_2(
      BuildPoint_2(content, arc.center),
      arc.radius,
      arc.startAngle,
      arc.endAngle,
      false
    );
  }

  function BuildPPolyLine_2(content: Context, polyline: Polyline_2) {
    let obj: any = getWasmObj(content);
    let vts = new obj.Vertexes_2();
    for (let i = 0; i < polyline.items.length; i++) {
      let vt = new obj.Vertex_2(
        polyline.items[i].x,
        polyline.items[i].y,
        polyline.items[i].bulge
      );
      vts.push_back(vt);
    }
    return new obj.Polyline_2(vts, polyline.isClose);
  }
  // function ConvertInfo(content: Context, tempInfo: DbLine): Line_2 | Circle_2 | Ellipse_2 {
  //     if (tempInfo instanceof DbLine) {
  //         return new Line_2(BuildPoint_2(content, tempInfo.start), BuildPoint_2(content, tempInfo.end));
  //     }

  //     return new Line_2(BuildPoint_2(content, { x: 0, y: 0 }), BuildPoint_2(content, { x: 0, y: 0 }));
  // }
  function ConvertInfoRewrite(content: Context, tempInfo: DBEntity | any) {
    let obj: any = getWasmObj(content);
    if (tempInfo instanceof DbLine || tempInfo.points) {
      let start = new Point_2(tempInfo.points[0], tempInfo.points[1]);
      let end = new Point_2(tempInfo.points.at(-3), tempInfo.points.at(-2));
      return BuildLine_2(
        content,
        new Line_2(BuildPoint_2(content, start), BuildPoint_2(content, end))
      );
    }

    if (tempInfo instanceof obj.Line_2) {
      let start = new Point_2(tempInfo.start.x, tempInfo.start.y);
      let end = new Point_2(tempInfo.end.x, tempInfo.end.y);
      return new Line_2(start, end);
    }
    if (tempInfo instanceof obj.Arc_2) {
      let { center, radius, start_angle, end_angle, is_clockwise } = tempInfo;
      center = new Point_2(tempInfo.center.x, tempInfo.center.y);
      return new Arc_2(center, radius, start_angle, end_angle);
    }
    if (tempInfo instanceof obj.Circle_2) {
      let center = new Point_2(tempInfo.center.x, tempInfo.center.y);
      return new Circle_2(center, tempInfo.radius);
    }
    if (tempInfo instanceof obj.EllipticArc_2) {
      let {
        center,
        major,
        minor,
        start_angle,
        end_angle,
        is_clockwise,
        angle,
      } = tempInfo;
      center = new Point_2(tempInfo.center.x, tempInfo.center.y);
      return new EllipticArc_2(
        center,
        major,
        minor,
        start_angle,
        end_angle,
        is_clockwise,
        angle
      );
    }
    if (tempInfo instanceof obj.Ellipse_2) {
      let { center, major, minor, angle } = tempInfo;
      center = new Point_2(tempInfo.center.x, tempInfo.center.y);
      return new Ellipse_2(center, major, minor, angle);
    }
    if (tempInfo instanceof obj.Polyline_2) {
      let { vertexes, is_closed } = tempInfo;
      let items: { x: number; y: number; z: number; bulge: number }[] = [];
      for (let i = 0; i < vertexes.size(); i++) {
        var vertex = vertexes.get(i);
        items.push({ x: vertex.x, y: vertex.y, z: 0, bulge: vertex.bulge });
      }

      return new Polyline_2(items, is_closed);
    }
  }

  export function BuildPoints_2(content: Context, points: Vector3[]) {
    let obj: any = getWasmObj(content);
    let controls = new obj.Points_2();
    for (let i = 0; i < points.length; i++) {
      controls.push_back(BuildPoint_2(content, points[i]));
    }
    return controls;
  }

  function ConvertResult(content: Context, resultList: any): Circle_2 {
    let tempOne = new Circle_2(new Point_2(0, 0), 0);
    let obj: any = getWasmObj(content);
    if (resultList.size() > 0) {
      let i = 0;
      var circle = resultList.get(i);
      var circle_ptr = obj.GetCircle_2(circle);
      tempOne = new Circle_2(
        new Point_2(circle_ptr.center.x, circle_ptr.center.y),
        circle_ptr.radius
      );
    }
    return tempOne;
  }

  function ConvertPointsResult(content: Context, resultList: any): Vector3[] {
    let tempList: Vector3[] = [];
    let obj: any = getWasmObj(content);
    if (resultList.size() > 0) {
      for (let i = 0; i < resultList.size(); i++) {
        var point = resultList.get(i);
        tempList.push(new Vector3(point.x, point.y, 0));
        point.delete();
      }
    }
    return tempList;
  }

  function ConvertNumbersResult(content: Context, resultList: any): number[] {
    let tempList: number[] = [];
    let obj: any = getWasmObj(content);
    if (resultList.size() > 0) {
      for (let i = 0; i < resultList.size(); i++) {
        var number = resultList.get(i);
        tempList.push(number);
      }
    }
    return tempList;
  }

  function ConvertResult_TangentTangentTangent(
    content: Context,
    resultList: any
  ): Circle_2 {
    let tempOne = new Circle_2(new Point_2(0, 0), 0);
    let obj: any = getWasmObj(content);
    let srcR = -1;
    if (resultList.size() > 0) {
      for (let i = 0; i < resultList.size(); i++) {
        var circle = resultList.get(i);
        var circle_ptr = obj.GetCircle_2(circle);
        if (srcR === -1) {
          srcR = circle_ptr.radius;
          tempOne = new Circle_2(
            new Point_2(circle_ptr.center.x, circle_ptr.center.y),
            circle_ptr.radius
          );
        }
        if (srcR > circle_ptr.radius) {
          srcR = circle_ptr.radius;
          tempOne = new Circle_2(
            new Point_2(circle_ptr.center.x, circle_ptr.center.y),
            circle_ptr.radius
          );
        }
      }
    }
    return tempOne;
  }

  export function GetTol(content: Context) {
    let camera = content.ViewManager.Camera;
    if (camera instanceof THREE.OrthographicCamera) {
      return (camera.top - camera.bottom) / content.Dom.offsetHeight;
    }
  }

  export function IntersectPoints(
    content: Context,
    target1: DBEntity,
    target2: DBEntity,
    tol: number
  ) {
    let obj: any = getWasmObj(content);
    let Intersect_2: any = obj.Intersect_2 || {};
    let l1 = ConvertInfoRewrite(content, target1);
    let l2 = ConvertInfoRewrite(content, target2);
    let resultList: any = [];
    resultList = Intersect_2.IntersectPoints_Tol(l1, l2, tol);
    return ConvertPointsResult(content, resultList);
  }

  export function BSpline_2_GetSamplingPoints(
    content: Context,
    points: Vector3[],
    pointNumber?: number,
    isFitting?: boolean
  ): {
    result: Vector3[];
    controls: Vector3[];
    knots: number[];
    fittings: Vector3[];
  } {
    if (pointNumber == undefined) {
      pointNumber = 50;
    }
    let obj: any = getWasmObj(content);
    var bspine_ptr;
    var bspline: any;

    if (isFitting) {
      let fittings = BuildPoints_2(content, points);
      bspine_ptr = obj.FittingTool_2.FittingBSpline(fittings);
      bspline = obj.GetBSpline_2(bspine_ptr);
    } else {
      let controls = BuildPoints_2(content, points);
      bspline = new obj.BSpline_2(controls);
    }

    let result: Vector3[] = [];
    let controls: Vector3[] = [];
    let fittings: Vector3[] = [];
    let knots: number[] = [];

    if (bspline) {
      let samplingCount = (points.length - 1) * pointNumber;
      var resultList = bspline.GetSamplingPoints(samplingCount);
      result = ConvertPointsResult(content, resultList);

      //获取控制点 直接通过属性获取
      let controls_List = bspline.controls;
      controls = ConvertPointsResult(content, controls_List);

      let knots_list = bspline.knots;
      knots = ConvertNumbersResult(content, knots_list);

      //获取拟合点 (控制点数量-2) 取样就是拟合点
      let fitting_number = controls.length - 2;
      let fittings_List = bspline.GetSamplingPoints(fitting_number);
      fittings = ConvertPointsResult(content, fittings_List);

      bspine_ptr?.delete();
      resultList.delete();
      fittings_List.delete();
      controls_List.delete();
      knots_list.delete();
    }
    return {
      result: result,
      controls: controls,
      knots: knots,
      fittings: fittings,
    };
  }

  // export function Wall_Road_Points(
  //   content: Context,
  //   points: Vector3[],
  //   width: number
  // ): Vector3[] {
  //   let obj: any = getWasmObj(content);
  //   let line_slots = new obj.LineSlotPtrs_2();

  //   // 使用立即执行函数 (IIFE) 来限定变量作用域
  //   for (let i = 0; i < points.length - 1; i++) {
  //     let pt1 = new obj.Point_2(points[i].x, points[i].y);
  //     let pt2 = new obj.Point_2(points[i + 1].x, points[i + 1].y);
  //     let line_slot1 = new obj.LineSlot_2(pt1, pt2, width);
  //     line_slots.push_back(line_slot1.CreatePtr());

  //     // 及时释放 Point_2 对象的内存
  //     // pt1.delete();
  //     // pt2.delete();
  //     // line_slot1.delete();
  //   }

  //   var road = obj.Trunking_2.GenerateRoad(line_slots);
  //   let result = [];

  //   // 处理生成的道路并释放内存
  //   for (let i = 0; i < road.size(); i++) {
  //     var line_ptr = road.get(i);
  //     var line = obj.GetLine_2(line_ptr);
  //     result.push(new Vector3(line.start.x, line.start.y, 0));
  //     result.push(new Vector3(line.end.x, line.end.y, 0));

  //     // 释放 Line_2 对象的内存
  //     line_ptr.delete();
  //     // line.delete();
  //   }

  //   // 释放 LineSlot_2 对象的内存
  //   for (let i = 0; i < line_slots.size(); i++) {
  //     var line_slot_ptr = line_slots.get(i);
  //     line_slot_ptr.delete();
  //   }

  //   // 释放 line_slots 对象的内存
  //   line_slots.delete();
  //   road.delete();
  //   return result;
  // }
  export function Draw_Wall_Road(
    context: Context,
    params: DrawWallRoadAcceptParams,
    datas: any[]
  ) {
    let { wasmObj, auxiliaryObj } = context;
    let { leftWallWidth, rightWallWidth, leftFaceLayer, rightFaceLayer } =
      params;
    let resultData: THREE.Vector3[][] = [];
    console.log("Draw_Wall_Road acceptParams", datas);
    let isError = false;
    auxiliaryObj.using(wasmObj, (factory: any) => {
      try {
        let lines_ptr = [];
        for (let i = 0; i < datas.length; i++) {
          let data = datas[i];
          if (data.type == drawWallType.drawLine) {
            let startP = factory.makeShared(
              "Point_2",
              data.dataInfo.startPoint.x,
              data.dataInfo.startPoint.y
            );
            let endP = factory.makeShared(
              "Point_2",
              data.dataInfo.endPoint.x,
              data.dataInfo.endPoint.y
            );

            let line_ptr = factory.makeShared("Line_2", startP, endP);
            lines_ptr.push(line_ptr);
          } else if (data.type == drawWallType.drawCircleArc) {
            let { center, radius, startAngle, endAngle, clockwise } =
              data.dataInfo;
            let center_pts = factory.makeShared("Point_2", center.x, center.y);
            let line_ptr = factory.track(
              factory.Module.MakeSharedArcPtrWithCenter(
                center_pts,
                radius,
                startAngle,
                endAngle,
                clockwise
              )
            );
            lines_ptr.push(line_ptr);
          }
        }

        const walls = lines_ptr.map((data: any, index: number) => {
          return factory.makeShared(
            "WallLineSlot_2",
            data,
            leftWallWidth,
            rightWallWidth,
            leftFaceLayer,
            rightFaceLayer
          );
        });
        const wallVec = factory.track(new wasmObj.WallLineSlotPtrs_2());
        for (let i = 0; i < walls.length; i++) {
          wallVec.push_back(walls[i]);
        }
        const curveGroups = factory.track(
          wasmObj.Trunking_2.GenerateWall(wallVec)
        );
        console.log("生成曲线组数量:", curveGroups.size());
        for (let i = 0; i < curveGroups.size(); i++) {
          const group = factory.track(curveGroups.get(i));
          // console.log(`曲线组 ${i}, 条数: ${group.size()}`);
          for (let j = 0; j < group.size(); j++) {
            const curve = factory.track(group.get(j));
            console.log(curve.type_name(), "type_name");
            let typeName = curve.type_name();
            let samplePoints = [];
            if (typeName == "Line_2") {
              samplePoints = curve.GetSamplingPoints(2);
            } else {
              samplePoints = curve.GetSamplingPoints(50);
            }
            let resultPoints: THREE.Vector3[] = [];

            for (let k = 0; k < samplePoints.size(); k++) {
              const pnt = factory.track(samplePoints.get(k));
              resultPoints.push(new THREE.Vector3(pnt.x, pnt.y, 0));
            }
            resultData.push(resultPoints);
          }
        }
        factory.cleanup();
      } catch (error) {
        factory.cleanup();
        DumpToCADCommand(datas);
        isError = true;
      }

      // console.log("调用 factory.cleanup 自动释放对象");
      // console.log("测试完成！");
    });

    if (isError) return undefined;
    return resultData;
  }

  export function DumpToCADCommand(resultData: any[]) {
    let str = resultData
      .map((data) => {
        let lineData = data?.dataInfo;
        return `(command "line" '(${lineData?.startPoint.x} ${lineData?.startPoint.y}) '(${lineData.endPoint.x} ${lineData.endPoint.y}) "")\n`;
      })
      ?.reduce((l, r) => l + r);

    console.log(str + "\n");
  }

  export function getMaxMin(
    content: Context,
    val: number
  ): {
    max: number;
    min: number;
  } {
    //min 2/3
    //max 1+1/3
    let min = (val * 2) / 3;
    let max = val * (1 + 1 / 3);
    return {
      max: max,
      min: min,
    };
  }

  export function RevCloud_GetPoint(
    content: Context,
    Vector3List: Vector3[]
  ): { point: THREE.Vector3; bulge: number }[] {
    let Module: any = getWasmObj(content);
    var pts = new Module.Points_2();
    let list: any[] = [];
    for (let i = 0; i < Vector3List.length; i++) {
      let point = new Module.Point_2(Vector3List[i].x, Vector3List[i].y);
      pts.push_back(point);
      list.push(point);
    }

    let lines = Module.RevcloudTool_2.RevcloudPolygonReverse(pts);
    let tempSet: Set<Vector3> = new Set();
    try {
      for (let i = 0; i < lines.size(); i++) {
        let line_ptr = lines.get(i);
        let line = Module.GetLine_2(line_ptr);
        try {
          let start = line.StartPoint();
          let end = line.EndPoint();

          tempSet.add(new Vector3(start.x, start.y, 0));
          if (i === lines.size() - 1) {
            tempSet.add(new Vector3(end.x, end.y, 0));
          }

          start.delete(); // 确保 start 被正确删除
          end.delete(); // 确保 end 被正确删除
        } finally {
        }
        line_ptr.delete(); // 确保 line_ptr 被正确删除
      }
    } finally {
      lines.delete(); // 确保 lines 被正确删除
      for (let i = 0; i < list.length; i++) {
        list[i].delete();
      }
      list = [];
      pts.delete(); // 确保 pts 被正确删除
    }

    let items: { point: THREE.Vector3; bulge: number }[] = [];
    for (let item of tempSet) {
      items.push({
        point: new Vector3(item.x, item.y, 0),
        bulge: 0,
      });
    }

    return items;
  }

  // 求样条曲线的切点
  export function getIsTangent(
    content: Context,
    points: THREE.Vector3[],
    p0: Vector3,
    p1: Vector3
  ) {
    let wasmObj = WasmUtil.getWasmObj(content);
    let controls = new wasmObj.Points_2();
    for (let i = 0; i < points.length; i++) {
      let pt = new wasmObj.Point_2(points[i].x, points[i].y);
      controls.push_back(pt);
    }
    let bspline = new wasmObj.BSpline_2(controls);
    let point0 = new wasmObj.Point_2(p0.x, p0.y);
    let point1 = new wasmObj.Point_2(p1.x, p1.y);
    let target = bspline.IsTangent_Tol(point0, point1, 0.003);
    return target;
  }

  // 求样条曲线的中点
  export function getMiddlePoint(content: Context, points: THREE.Vector3[]) {
    let wasmObj = WasmUtil.getWasmObj(content);
    let controls = new wasmObj.Points_2();
    for (let i = 0; i < points.length; i++) {
      let pt = new wasmObj.Point_2(points[i].x, points[i].y);
      controls.push_back(pt);
    }
    let bspline = new wasmObj.BSpline_2(controls);
    let mid = bspline.MiddlePoint();
    return new Vector3(mid.x, mid.y, 0);
  }

  // // 求椭圆的切点
  // export function getEllipseTangent(
  //   content: Context,
  //   ellipse: EllipseInfo,
  //   p0: Vector3,
  //   p1: Vector3
  // ) {
  //   let wasmObj = WasmUtil.getWasmObj(content);
  //   let origin = new wasmObj.Point_2(ellipse.origin.x, ellipse.origin.y);
  //   let major = ellipse.major;
  //   let minor = ellipse.minor;
  //   let angle = ellipse.rotation;
  //   let ellipse_2 = new wasmObj.Ellipse_2(origin, major, minor, angle);
  //   let point0 = new wasmObj.Point_2(p0.x, p0.y);
  //   let point1 = new wasmObj.Point_2(p1.x, p1.y);
  //   let target = ellipse_2.IsTangent(point0, point1);
  //   return target;
  // }

  // 多段线偏移
  export function getOffsetPolyline(
    content: Context,
    points: { x: number; y: number; z: number; bulge: number }[],
    offset: number,
    curPoint: Vector3
  ) {
    let wasmObj = WasmUtil.getWasmObj(content);
    let vts = new wasmObj.Vertexes_2();
    // console.log(points,curPoint,offset,'points')
    let curP = new wasmObj.Point_2(curPoint.x, curPoint.y);
    let resObject = [];
    let startPoint = new THREE.Vector3(points[0].x, points[0].y, 0);
    let endPoint = new THREE.Vector3(
      points[points.length - 1].x,
      points[points.length - 1].y,
      0
    );
    let isClose = false;
    if (startPoint.distanceTo(endPoint) < 0.01) {
      isClose = true;
      points.pop();
    }

    for (let i = 0; i < points.length; i++) {
      let vt = new wasmObj.Vertex_2(points[i].x, points[i].y, points[i].bulge);
      vts.push_back(vt);
    }

    let polyline = new wasmObj.Polyline_2(vts, isClose);
    let polyline_ptrs = polyline.GetOffsetPolylineByPoint(curP, offset);
    for (let i = 0; i < polyline_ptrs.size(); i++) {
      var polyline_ptr = polyline_ptrs.get(i);
      var polyline1 = wasmObj.GetPolyline_2(polyline_ptr);
      var vertexes = polyline1.vertexes; //遍历顶点
      let points = [];

      for (let i = 0; i < vertexes.size(); i++) {
        var vertex = vertexes.get(i);
        points.push({ x: vertex.x, y: vertex.y, z: 0, bulge: vertex.bulge });
      }
      resObject.push({
        isClose: polyline1.is_closed, //是否闭合
        points,
      });
      polyline_ptr.delete();
    }
    return resObject;
  }
}
